import PuzzleService from '_services/rest/modules/puzzle';
import { handleResourceLoadError } from '_utils';

export default {
  state: {
    puzzleNumberSquare: null,
    hasChanges: false,
  },
  mutations: {
    setPuzzleNumberSquare(state, puzzleNumberSquare) {
      state.puzzleNumberSquare = puzzleNumberSquare;
    },
    setHasChanges(state, status) {
      state.hasChanges = status;
    },
  },
  actions: {
    setPuzzleNumberSquare({ commit }, model) {
      commit('setPuzzleNumberSquare', model);
    },
    setHasChanges({ commit }, status) {
      commit('setHasChanges', status);
    },
    getPuzzleNumberSquare({ commit, dispatch }, id) {
      return PuzzleService.getPuzzleById(id)
        .then(response => {
          commit('setPuzzleNumberSquare', response);
          commit('setHasChanges', false);
        })
        .catch(error => {
          handleResourceLoadError(
            dispatch,
            error,
            'admin-puzzle-number-square-list',
          );
        });
    },
  },
};
